import { useState, useEffect, useRef, useCallback } from "react";
import { listReviews } from "../lib/api";

// Same race-guarded shape as useProjects.
export function usePerformanceReviews(filters) {
  const [data, setData] = useState({
    reviews: [],
    total: 0,
    page: 1,
    limit: 20,
    hasMore: false,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const reqId = useRef(0);
  const key = JSON.stringify(filters);

  const refresh = useCallback(async () => {
    const my = ++reqId.current;
    setLoading(true);
    setError(null);
    try {
      const res = await listReviews(filters);
      if (my === reqId.current) setData(res);
    } catch (e) {
      if (my === reqId.current) setError(e);
    } finally {
      if (my === reqId.current) setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  useEffect(() => {
    refresh();
    return () => {
      // Invalidate any in-flight request on unmount so a late response can't
      // setState afterwards. reqId is a counter, not a DOM node ref.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      reqId.current++;
    };
  }, [refresh]);

  return { ...data, loading, error, refresh };
}
